export default __webpack_public_path__ + "static/mediaCharOne-d117674134345bc52cae1638e48d7e96.png";